import React from "react";
import styled from "styled-components";

const Button = styled.button`
  padding: 0.65em 2.5em;
  font-size: 15px;
  font-weight: 550;
  border-radius: 5px;
  cursor: pointer;
  width: fit-content;
  box-shadow: none;
  outline: 0;

  &[disabled] {
    color: #000;
    cursor: not-allowed;
    background: #d2d2d2;
    border: 0px;

    &:hover {
      color: rgba(0, 0, 0, 0.66);
    }
  }

  &.condensed {
    background: ${(props) => (props.primary ? "palevioletred" : "white")};
    color: ${(props) => (props.primary ? "white" : "palevioletred")};
    color: white;
    background: #0381FC;
    border: 0;
  }
  &.outlined {
    color: #0381FC;
    background: transparent;
    border: 1px solid #0381FC;
  }

  &.linkable {
    color: #0381FC;
    background: transparent;
    border: 0px;
    padding: 5px;
  }

  &.text {
    background: transparent;
    padding: 6px 12px;
    border: 0px;
    color: #0381FC;

    &:hover {
      background: rgba(25, 118, 210, 0.04);
    }
  }
`;

function GButton(props) {
  return (
    <Button
      type={props.type}
      className={props.variant}
      onClick={props.onClick}
      style={props.style}
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
}

export default GButton;
